export interface SearchIndexItem {
  title: string;
  path: string;
  section: string;
  content: string;
}

export const searchIndex: SearchIndexItem[] = [
  {
    title: "Getting Started",
    path: "/",
    section: "Getting Started",
    content: "Welcome to Ana DevOps! Your AI-powered infrastructure automation platform. Transform natural language into production-ready infrastructure code with Terraform, Kubernetes, and more. Learn how to create projects, chat with Ana, and deploy infrastructure in minutes."
  },
  {
    title: "Chat with Ana",
    path: "/chat",
    section: "Core Features",
    content: "Interact with Ana, your AI-powered DevOps assistant. Generate infrastructure code from natural language descriptions. Ana understands Terraform, Kubernetes, Docker, and CI/CD pipelines. Simply describe what you need and Ana creates production-ready code following best practices."
  },
  {
    title: "Projects",
    path: "/projects",
    section: "Core Features",
    content: "Organize your infrastructure work into projects. Create and manage projects for different environments, applications, or teams. Projects are containers for all your infrastructure code, configurations, and deployments."
  },
  {
    title: "Code Editor",
    path: "/code-editor",
    section: "Core Features",
    content: "View and edit infrastructure code generated by Ana. Syntax highlighting for Terraform, Kubernetes YAML, Docker, and CI/CD pipelines. Access visualization tools directly from the editor with the eye button."
  },
  {
    title: "Visualisation",
    path: "/visualisation",
    section: "Core Features",
    content: "Visualize your infrastructure architecture as interactive diagrams. Add components visually with drag-and-drop. Preview deployment costs and plans before deploying. Deploy infrastructure to AWS, Azure, or GCP with confidence."
  },
  {
    title: "Cloud Analyzer",
    path: "/cloud-analyzer",
    section: "Core Features",
    content: "Analyze existing cloud infrastructure for optimization opportunities. Get recommendations for cost savings, security improvements, and performance tuning. Export existing infrastructure to code for better management."
  },
  {
    title: "Integrations",
    path: "/integrations",
    section: "Configuration",
    content: "Connect Ana to your cloud providers and DevOps tools. Set up AWS, Azure, and GCP integrations with detailed step-by-step guides. Configure GitHub, GitLab, Jenkins, ArgoCD, Terraform Cloud, Datadog, and Prometheus integrations."
  },
  {
    title: "AWS Integration",
    path: "/integrations",
    section: "Cloud Providers",
    content: "Deploy to AWS using IAM credentials. Create IAM users, attach permissions, generate access keys, and configure in Ana. Supports EC2, S3, RDS, VPC, Lambda, and all AWS services through Terraform."
  },
  {
    title: "Azure Integration",
    path: "/integrations",
    section: "Cloud Providers",
    content: "Connect using Azure Service Principals. Create service principals via Azure CLI or Portal, assign permissions, and configure in Ana. Deploy to Azure App Service, Azure SQL, AKS, and more."
  },
  {
    title: "GCP Integration",
    path: "/integrations",
    section: "Cloud Providers",
    content: "Integrate using GCP Service Accounts. Create service accounts, assign IAM roles, generate JSON keys, and configure in Ana. Deploy to Compute Engine, GKE, Cloud SQL, and all GCP services."
  },
  {
    title: "Infrastructure as Code",
    path: "/chat",
    section: "Technologies",
    content: "Generate Terraform configurations, AWS CloudFormation templates, Azure ARM templates, and Pulumi programs. Ana creates production-ready infrastructure as code following best practices and security standards."
  },
  {
    title: "Kubernetes",
    path: "/chat",
    section: "Technologies",
    content: "Create Kubernetes manifests, Helm charts, and Kustomize configurations. Deploy to EKS, AKS, or GKE with service mesh, monitoring, and CI/CD integration. Ana generates complete cluster configurations."
  },
  {
    title: "CI/CD Pipelines",
    path: "/chat",
    section: "Technologies",
    content: "Generate GitHub Actions workflows, GitLab CI/CD pipelines, Jenkins pipelines, and Azure DevOps configurations. Automate testing, building, and deployment with Ana-generated pipeline code."
  },
  {
    title: "Cost Preview",
    path: "/visualisation",
    section: "Features",
    content: "Preview infrastructure costs before deployment. See per-resource costs, monthly projections, and cost breakdowns by service type. Get cost optimization suggestions to stay within budget."
  },
  {
    title: "Deployment",
    path: "/visualisation",
    section: "Features",
    content: "Deploy infrastructure using Terraform. Review deployment plans, check cost estimates, and deploy to AWS, Azure, or GCP. Ana handles authentication, resource creation, and state management."
  },
  {
    title: "Infrastructure Optimization",
    path: "/cloud-analyzer",
    section: "Features",
    content: "Identify cost-saving opportunities, security vulnerabilities, and performance improvements. Cloud Analyzer scans existing infrastructure and provides actionable recommendations with estimated savings."
  },
  {
    title: "Export to Code",
    path: "/cloud-analyzer",
    section: "Features",
    content: "Convert existing cloud resources to infrastructure as code. Export AWS, Azure, or GCP infrastructure to Terraform format. Enable version control and reproducibility for legacy infrastructure."
  }
];
